import { render, staticRenderFns } from "./GoodsClassForm.vue?vue&type=template&id=6bf8fde6&scoped=true&"
import script from "./GoodsClassForm.vue?vue&type=script&lang=js&"
export * from "./GoodsClassForm.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClassForm.vue?vue&type=style&index=0&id=6bf8fde6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8fde6",
  null
  
)

export default component.exports